import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[ecpNavLink]',
    standalone: false
})
export class NavItemLinkDirective {
  constructor(public element: ElementRef) {}
}
